import { css } from 'emotion';
import { makeStyles } from '@surveycake/rc';

export const messages = css(`
	&:not(:empty) {
		margin-bottom: 8px;
	}
	:lang(ar){
		transform: scaleX(-1);
		direction: rtl;
	}
`);

export const info = css(`
	display: inline-block;
	line-height: 28px;
	margin-right: 10px;
`);

export const useStyles = makeStyles([
	[
	  'inportantInfo',
	  theme => `
		  color: ${theme.color.semantic.error};
	  `
	]
  ]);
